import React from 'react';
import '../../Styles/Dashboard.scss';
import Dashboard__Kpi from './Dashboard__Kpi';
import Dashboard__LineAreaChart from './Dashboard__LineAreaChart';
import Dashboard__BarChart from './Dashboard__BarChart';
import Dashboard__PieChart from './Dashboard__PieChart';
import Dashboard__Table from './Dashboard__Table';

export default function Dashboard(props) {
    return (
        <React.Fragment>
            <div className="kpi-wrapper-container">
                <Dashboard__Kpi kpiName="Time to serve" materialIcon="timer"></Dashboard__Kpi>
                <Dashboard__Kpi kpiName="Average order size" materialIcon="graphic_eq"></Dashboard__Kpi>
                <Dashboard__Kpi kpiName="Orders this week" materialIcon="assignment"></Dashboard__Kpi>
                <Dashboard__Kpi kpiName="Revenue this week" materialIcon="attach_money"></Dashboard__Kpi>
            </div>
            <div className="dashboard__graph-container">
                <Dashboard__LineAreaChart></Dashboard__LineAreaChart>
                <Dashboard__BarChart></Dashboard__BarChart>
                <Dashboard__PieChart></Dashboard__PieChart>
            </div>

            <div className="dashboard__table-div">
                <Dashboard__Table></Dashboard__Table>
            </div>
        </React.Fragment>
    );
}